var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-button',{class:`floating-action-button floating-action-button--${_vm.color}`,attrs:{"icon":`floating-action-button__icon ${_vm.icon}`},on:{"click":_vm.clickFunction}},[_vm._v(" "+_vm._s(_vm.label)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }